<template>
    <edit-resource
        :form="form"
        :title="title"
        @close="$emit('close')"
        @submit="saveAward"
    >
        <div class="w-600 flex">
            <div class="w-1/2 flex items-center justify-center mr-32">
                <div class="w-full">
                    <siu
                        v-model="form.logo_path_queued_id"
                        :image="imageUrl"
                        classes="h-240 rounded shadow-md"
                        icon-location="corner"
                        @clear="clearPhoto"
                        @success="resetPhoto">
                    </siu>
                </div>
            </div>
            <div class="w-1/2">
                <simple-input
                    v-model="form.name"
                    class="mb-16">
                    {{ $t('general.alt_text') }}
                </simple-input>
                <simple-input
                    v-model="form.url"
                    class="mb-32">
                    {{ $t('company.website') }}
                </simple-input>
            </div>
        </div>
    </edit-resource>
</template>

<script>
import EditResource from './EditResource.vue';
import Input from '../forms/Input.vue';
import Translatable from '../forms/Translatable.vue';
import Award from '../../models/Award';
import * as awards from '../../services/AwardService';
import _mapValues from 'lodash/mapValues';
import _isEqual from 'lodash/isEqual';
import Form from '../../etc/forms/Form';
import {normalizeJson} from '../../../shared/helpers';
import SingleImageUpload from '../forms/SingleImageUpload.vue';
import {useRepo} from 'pinia-orm';

function getFields() {
    return [
        {name: 'name', value: null, rules: ['required']},
        {name: 'url', value: ''},
        {name: 'logo_path', value: 'default'},
        {name: 'logo_path_queued_id', value: null},
    ];
}

export default {
    components: {
        'edit-resource': EditResource,
        'simple-input': Input,
        'translatable': Translatable,
        'siu': SingleImageUpload,
    },
    props: {
        award: Object,
    },
    data: function () {
        return {
            form: this.generateForm(),
            savingAward: false,
        };
    },
    computed: {
        title() {
            return this.$t(this.award ? 'general.edit_subject' : 'general.add_subject', {subject: this.$t('site_editor.awards.single')});
        },
        imageUrl: {
            get() {
                return (typeof this.award !== 'undefined') ? this.award.image_url : null;
            },
        },
    },
    methods: {
        generateForm() {
            let fields = getFields();
            if (this.award) {
                fields.forEach((field, index) => {
                    if (this.award.hasOwnProperty(field.name)) {
                        fields[index].value = JSON.parse(JSON.stringify(this.award[field.name]));
                    }
                });
            }
            return new Form(fields);
        },
        async saveAward() {
            if (this.form.data.logo_path_queued_id === null) {
                delete this.form.data.logo_path_queued_id;
            }

            if (this.award && this.award.id) {
                await this.updateAward();
            } else {
                let award = await this.createAward();
                if (award) {
                    this.$emit('created', award.id);
                }
            }

            this.$emit('close');
        },
        updateAward() {
            if (this.form.data.logo_path === 'default') {
                delete this.form.data.logo_path;
            }

            return this.form.submit(data => awards.update(this.award.id, {
                data: {
                    type: 'awards',
                    attributes: data,
                },
            })).then(result => {
                return useRepo(Award).save(normalizeJson(result));
            });
        },
        createAward() {
            delete this.form.data.logo_path;

            return this.form.submit(data => awards.store({
                data: {
                    type: 'awards',
                    attributes: data,
                },
            })).then(result => {
                return useRepo(Award).save(normalizeJson(result));
            });
        },
        clearPhoto() {
            this.form.data.logo_path = null;
        },
        resetPhoto() {
            this.form.data.logo_path = 'default';
        },
    },
};
</script>
